import React from 'react';

// Legacy navigation bar — superseded by AppShell's sidebar + header.
export const Navigation: React.FC = () => null;
